import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiClient } from '../http/api-client';

export interface BenefitFlyer {
  id: string;
  teamId: string;
  displayName: string;
  filename: string;
  size: number;
  uploadedBy: string;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class BenefitFlyersService {
  readonly changed = new Subject<string>();
  private api = inject(ApiClient);
  list(teamId: string): Promise<BenefitFlyer[]> {
    return this.api.one('teams', teamId).one('benefit-flyers').get().toPromise();
  }
  async upload(teamId: string, name: string, file: File, flyerId?: string): Promise<void> {
    const resource = this.api.one('teams', teamId).one('benefit-flyers');
    const body = await file.arrayBuffer();
    const params = { displayName: name, filename: file.name };
    const headers = { 'Content-Type': 'application/pdf' };
    await (flyerId ? resource.one(flyerId).customPUT(body, undefined, params, headers)
      : resource.customPOST(body, undefined, params, headers)).toPromise();
    this.changed.next(teamId);
  }
  async remove(teamId: string, flyerId: string): Promise<void> {
    await this.api.one('teams', teamId).one('benefit-flyers', flyerId).remove().toPromise();
    this.changed.next(teamId);
  }
  download(teamId: string, flyerId: string): Promise<{ url: string }> {
    return this.api.one('teams', teamId).one('benefit-flyers', flyerId).one('download').get().toPromise();
  }
}
